module.exports = __webpack_public_path__ + "img/stats_mobile_de.a037887.png";